import {
  POST_ADD_HASH_TAG,
  UPDATE_ADD_POST_VISIBILITY,
  CHANGE_ADD_POST_VISIBILITY_UPDATED_BY_USER_STATUS,
  POST_UPDATE_EDITOR_STATE,
  POST_TOGGLE_UPDATE_STATUS,
  POST_UPDATE_IMAGES,
  POST_UPDATE_GIFS,
  POST_UPDATE,
  POST_ADD_MENTION,
  POST_CLEAR,
  UPDATE_TAGS_RECOMMENDATIONS,
  UPDATE_ADD_POST_SENTIMENT,
} from 'actions/actionTypes';
import { EditorState } from 'draft-js';
import { selectIsVisibilityUpdatedByUser, selectPostData, selectVisibilityTypeFromPost } from 'selectors/addPost';

import { ADD_POST_MODAL_TYPES } from 'constants/ProjectConstants';

import { convertEmployeeIntoMentionData } from 'services/helpers/post';
import { editPost, createPost, debouncedAttributePrediction } from 'services/post';

export function setEditorStateAction(editorState) {
  return { type: POST_UPDATE_EDITOR_STATE, editorState };
}

export function toggleIsUpdatingAction() {
  return { type: POST_TOGGLE_UPDATE_STATUS };
}

export function updateImageAction(imageMediaObject) {
  return { type: POST_UPDATE_IMAGES, image: imageMediaObject };
}

export function updateGifAction(gifMediaObject) {
  return { type: POST_UPDATE_GIFS, gif: gifMediaObject };
}

export function updatePostAction(post = {}) {
  return { type: POST_UPDATE, post };
}

export function postAddTagAction(tagData) {
  return {
    type: POST_ADD_HASH_TAG,
    data: tagData,
  };
}

export function postAddMentionAction(employee) {
  return {
    type: POST_ADD_MENTION,
    data: convertEmployeeIntoMentionData(employee),
  };
}

export function updateSentiment(newSentiment) {
  return {
    type: 'ADDPOST_UPDATE_SENTIMENT',
    newSentiment,
  };
}

export function updateSentimentAction(newSentiment) {
  return {
    type: UPDATE_ADD_POST_SENTIMENT,
    data: newSentiment,
  };
}

// TODO: on modal close, clear all the data
export function toggleAddPostModal(modalType = ADD_POST_MODAL_TYPES.CREATE_POST) {
  return (dispatch, getState) => {
    if (getState().addPostModal.open) {
      dispatch(updateTagsRecommendationsAction([]));
      dispatch(updateEditorState(EditorState.createEmpty()));
    }
    dispatch({
      type: 'TOGGLE_MODAL',
      modalType,
    });
  };
}

export const debouncedAttributePredictionAction =
  ({ text, macros }) =>
  (dispatch) => {
    const onSuccess = (tags) => dispatch(updateTagsRecommendationsAction(tags));
    debouncedAttributePrediction({ text, macros, onSuccess });
  };

export function getMediaObjectFromUploads(images = [], gifs = []) {
  const media = [...images, ...gifs];
  return media.map((m) => ({
    ...m,
    uuid: m.id || m.uuid,
  }));
}

export function getApiDataForPost(post) {
  const { id } = post;
  const { editorState } = post;
  const visibilityType = selectVisibilityTypeFromPost(post);
  const { images } = post;
  const { gifs } = post;
  const media = getMediaObjectFromUploads(images, gifs);
  const { sentiment } = post;
  return { id, editorState, visibilityType, media, sentiment };
}

export function updateTagsRecommendationsAction(tags) {
  return {
    type: UPDATE_TAGS_RECOMMENDATIONS,
    tags,
  };
}

export function createOrEditPostAction({ media, useMoney, feedbackType = null, feedback_visibility }) {
  return (dispatch, getState) => {
    const state = getState();
    const { id, editorState, visibilityType, media, sentiment } = getApiDataForPost(selectPostData(state));
    return id
      ? editPost({
          postId: id,
          editorState,
          media,
          visibilityType,
          useMoney,
          sentiment: 'NEUTRAL',
          feedbackType,
          feedback_visibility,
        })
      : createPost({
          editorState,
          media,
          visibilityType,
          useMoney,
          sentiment: 'NEUTRAL',
          feedbackType,
          feedback_visibility,
        });
  };
}

export function debouncedPredictVisibilityAction({ text }) {
  return (dispatch, getState) => {
    const state = getState();
    const isVisibilityUpdatedByUser = selectIsVisibilityUpdatedByUser(state);
    // don't predict anymore if the user has already updated the visibility manually
    // if (isVisibilityUpdatedByUser) return;
    // const onSuccess = visibility => {
    //   dispatch(updateAddPostVisibilityAction(visibility));
    // };
    // debouncedVisibilityPrediction({ text, onSuccess });
  };
}

export function updateEditorState(editorState) {
  return (dispatch, getState) => {
    dispatch({
      type: 'ADD_POST_EDITOR_UPDATE_STATE',
      data: editorState,
    });
  };
}

export function updateAddPostVisibilityAction(visibilityType) {
  if (!visibilityType) throw new Error('visibility type is not provided while updating the visibility');
  return {
    type: UPDATE_ADD_POST_VISIBILITY,
    data: { visibilityType },
  };
}

export function updateManualVisibilityUpdateStatusAction(isUpdatedByUser) {
  return {
    type: CHANGE_ADD_POST_VISIBILITY_UPDATED_BY_USER_STATUS,
    data: { isUpdatedByUser },
  };
}

export function clearPostDataAction(post = {}) {
  return { type: POST_CLEAR, post };
}

// --- the code below is old, some of it might be used in the future, also some of it is being used in some old legacy code

const PostTag = {
  id: null,
  name: null,
  predicted: false,
  display: true,
};

function addPredictedTypeToData(data) {
  data.forEach((d) => (d.predicted = true));
}

export function updateAddPostMoolah(value) {
  return {
    type: 'ADDPOST_UPDATE_MOOLAH',
    data: value,
  };
}

export function updateDeliverable(index, deliverable) {
  return {
    type: 'DELIVER_UPDATE',
    index,
    data: { ...deliverable, predicted: false },
  };
}

export function removeDeliverable(index) {
  return { type: 'DELIVER_REMOVE', index };
}

export function clearDeliverable() {
  return { type: 'DELIVER_CLEAR' };
}

export function addEmptyDeliverable() {
  return { type: 'DELIVER_ADD', data: { ...PostTag } };
}

export function addDeliverable(data) {
  return {
    type: 'DELIVER_ADD',
    data,
  };
}

export function updateDriver(index, driver) {
  return {
    type: 'DRIVER_UPDATE',
    index,
    data: { ...driver, predicted: false },
  };
}

export function removeDriver(index) {
  return { type: 'DRIVER_REMOVE', index };
}

export function clearDriver() {
  return { type: 'DRIVER_CLEAR' };
}

export function addEmptyDriver() {
  return { type: 'DRIVER_ADD', data: { ...PostTag } };
}

export function updateDevelopable(index, developableSelectResult) {
  return {
    type: 'DEVELOP_UPDATE',
    index,
    data: { ...developableSelectResult, predicted: false },
  };
}

export function removeDevelopable(index) {
  return { type: 'DEVELOP_REMOVE', index };
}

export function clearDevelopable() {
  return { type: 'DEVELOP_CLEAR' };
}

export function addEmptyDevelopable() {
  return (dispatch) => {
    dispatch({ type: 'DEVELOP_ADD', data: { ...PostTag } });
  };
}
